import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import IconButton from '@softwaredev_cegeka/stix-core/dist/components/Button/subcomponents/IconButton'
import LinkButton from '@softwaredev_cegeka/stix-core/dist/components/Button/subcomponents/LinkButton'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'
import { generateEmailTemplate } from '../utils/generateEmailTemplate'
// Styles
import styles from './preview.module.scss'

Preview.propTypes = {
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
    subcategory: PropTypes.string,
}

function Preview(props) {
    const { content } = props
    const [htmlContent, setHtmlContent] = React.useState('')
    const [show, setShow] = React.useState(false)

    // Generate the newsletter template only when the user explicitly
    // requests a preview. This prevents automatic regeneration when
    // unrelated props (like title) change during editing.
    const handlePreview = async () => {
        const template = await generateEmailTemplate({
            content,
            title: props.title,
            subcategory: props.subcategory,
        })
        setHtmlContent(template)
        setShow(true)
    }

    if (!content) {
        return null
    }

    return (
        <>
            <LinkButton onClick={handlePreview} label="Preview newsletter" />
            <div className={cx(styles.container, { [styles.show]: show })}>
                <IconButton
                    className={styles.close}
                    variant="secondary"
                    size="xxs"
                    label="close"
                    icon={<Icon icon="close" />}
                    onClick={() => setShow(false)}
                />
                <iframe
                    srcDoc={htmlContent}
                    title="newsletter-preview"
                    width={'100%'}
                    height={'100%'}
                    className={styles.preview}
                />
            </div>
        </>
    )
}

export default Preview
